import { create } from 'zustand';
import {
  getLocalStorageValue,
  SEEDANCE_STORAGE_KEYS,
  setLocalStorageValue,
} from '../utils/seedanceStorage';

export type SeedanceTheme = 'light' | 'dark';

function readStoredTheme(): SeedanceTheme {
  return getLocalStorageValue(SEEDANCE_STORAGE_KEYS.theme) === 'dark' ? 'dark' : 'light';
}

interface SeedanceThemeState {
  theme: SeedanceTheme;
  setTheme: (theme: SeedanceTheme) => void;
  toggleTheme: () => void;
}

export const useSeedanceThemeStore = create<SeedanceThemeState>((set, get) => ({
  theme: readStoredTheme(),
  setTheme: (theme) => {
    setLocalStorageValue(SEEDANCE_STORAGE_KEYS.theme, theme);
    set({ theme });
  },
  toggleTheme: () => {
    const next: SeedanceTheme = get().theme === 'light' ? 'dark' : 'light';
    get().setTheme(next);
  },
}));
